<template>
  <div
    class="quality-block relative z-10"
    id="participant-connection-indicator"
    :class="colorClass"
  >
    <div style="font-size: 16px" class="tooltip">
      <!--      <span class="tooltip-text ml-2">-->
      <!--        {{ Math.floor(statsValue) }}% ({{-->
      <!--          colorClass.charAt(0).toUpperCase() + colorClass.slice(1)-->
      <!--        }})-->
      <!--      </span>-->
      <div class="quality-icon h-3 w-3">
        <svg
          class="h-3 w-3"
          aria-hidden="true"
          height="16"
          width="16"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6 17.25H3V21h3v-3.75ZM7.5 21A1.5 1.5 0 0 1 6 22.5H3A1.5 1.5 0 0 1 1.5 21v-3.75a1.5 1.5 0 0 1 1.5-1.5h3a1.5 1.5 0 0 1 1.5 1.5V21Zm7.5 0V10.5A1.5 1.5 0 0 0 13.5 9h-3A1.5 1.5 0 0 0 9 10.5V21a1.5 1.5 0 0 0 1.5 1.5h3A1.5 1.5 0 0 0 15 21Zm1.5 0a1.5 1.5 0 0 0 1.5 1.5h3a1.5 1.5 0 0 0 1.5-1.5V3A1.5 1.5 0 0 0 21 1.5h-3A1.5 1.5 0 0 0 16.5 3v18Zm-3-10.5h-3V21h3V10.5ZM21 3h-3v18h3V3Z"
          ></path>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';

export default {
  props: {
    statsValue: {
      type: Number,
      required: true,
      default: 0,
    },
  },
  setup(props) {
    const colorClass = computed(() => {
      if (props.statsValue > 80) {
        return 'good';
      }
      if (props.statsValue > 40) {
        return 'normal';
      }
      if (props.statsValue > 1) {
        return 'bad';
      }
      if (props.statsValue === 0) {
        return 'connecting';
      }

      return 'no-connection';
    });

    return {
      colorClass,
    };
  },
};
</script>

<style>
.tooltip .tooltip-text {
  visibility: hidden;
  padding: 3px 5px 1px 5px;
  border: 1px solid #d8d8d8;
  width: max-content;
  background-color: #eeeeee;
  color: #134e4a;
  text-align: center;
  border-radius: 6px;
  font-weight: 500;
  font-size: smaller;
  position: absolute;
  opacity: 1;
  z-index: 1;
  top: 5px;
  left: 100%;
}
.tooltip .tooltip-text::after {
  content: '';
  position: absolute;
  top: 50%;
  right: 100%;
  margin-top: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent #e5e5e5 transparent transparent;
}

.tooltip:hover .tooltip-text {
  visibility: visible;
}

.quality-block {
  padding: 2px;
  border-radius: 4px;
}

.quality-block.connecting {
  background: transparent;
  border: 1px solid #eaeaea;
}

.quality-block.good {
  background-color: #37d4bf;
}

.quality-block.normal {
  background-color: #f8ae1a;
}

.quality-block.bad {
  background-color: #ff4343;
}

.quality-block.no-connection {
  background-color: #666;
}

.quality-icon {
  fill: #fff;
}
</style>
